import { createAsyncThunk } from "@reduxjs/toolkit";
import "react-toastify/dist/ReactToastify.css";

import { formatQueryParams } from "helpers/format";
import popupApi from "api/popupApi";

export const getPopupList = createAsyncThunk(
  "Popup",
  async (params: any = {}) => {
    try {
      const response = await popupApi.popupList(
        formatQueryParams(params)
      );
      return response;
    } catch (error) {
      return error;
    }
  }
);
export const getPopupDetail =  async(id: string | number ,  params: any = {}) => {
  try{
    const response = await popupApi.getPopupDetail(id, params)
    return response;
  }catch (error) {
    return error;
  }
};

export const postPopup = async (data: any = {}) => {
  try{
    const response = await popupApi.createPopup(data);
    return response;
  }catch (error) {
    return error;
  }
};

export const putPopup = async (id: string | number , data: any = {}) => {
  try{
    const response = await popupApi.updatePopup(id, data);
    return response;
  }catch (error) {
    return error;
  }
};